import GET_CATEGORIES from "../plugins/getCategories"

const [w, d, l, content] = [window, document, location, 'service']

const replace_item = () => {
  $('.contents .wrapLink', '.element_list').each((i, obj) => {
    let href = obj.getAttribute('href')
    let thumb = obj.querySelector('.thum_img > img').getAttribute('src')
    let is_new = obj.querySelectorAll('span.new').length > 0 ? true : false
    let catObj = obj.querySelector('.catetitle a')
    let cat = catObj ? catObj.innerText : ''
    let dateObj = obj.querySelector('p.date')
    let date = dateObj ? dateObj.innerText : false
    let title = obj.querySelector('h5 > a').getAttribute('title')
    let desc = obj.querySelector('p.catch')? obj.querySelector('p.catch').innerText : ''

    $(obj).replaceWith(`
    <a href="${href}" class="${content}-item">
      <figure class="${content}-item__img">
        <div class="${content}-item__img-cover" style="background-image:url(${thumb})"><img src="${thumb}" alt="${title}" width=""></div>
      </figure>
      <div class="${content}-item__body">
        <h5 class="subject">
          <span class="title">${title}</span>
          <i class="fa fa-angle-right"></i></strong>
        </h4>
      </div>
    </a>
    `)
  })
}


const detail_init = async the_id => {

  // 全記事取得
  let articles = await $.getArticles({
    content,
    post_id: the_id
  })
  let categories = await $.getCategories({
    content
  })
  let the_article = articles.filter(a => (a.id == the_id)).shift()
  the_article.category = categories.filter(c => c.id == the_article.category)[0]

  let $head = $(`
    <div class="${content}-detail__head">
      <figure class="img">
        <img src="${the_article.thumb}" alt="">
      </figure>
      <div class="body">
        <div class="${content}-detail__head-line hidden-xsmall">
        <em class="is-line"><span></span></em>
        <svg class="is-icon" width="15" height="15">
          <use xlink:href="/asset/svg/sprite.symbol.svg#kira"></use>
        </svg>
      </div>
      ${the_article.category ? `<span class="cat">${the_article.category.name}</span>`: '<span class="cat">その他</span>' }
      <h3 class="title">${the_article.title}</h3>
      ${the_article.desc.length ? `<p class="desc">${the_article.desc}</p>`: '' }
    </div>
    </div>
  `)
  $('.element_detail > .title, .detail_title').remove()
  $head.prependTo('.element_detail')

  //詳細ページのカテゴリに応じてcurrentクラスを付ける、カテゴリ無しの時は「その他」にcurrentを付ける
  $('.service-catelist > a').each( function() {
    const href = this.getAttribute('href');

    if ( the_article.category ) {
      if ( href === the_article.category.href ) {
        this.classList.add('current')
      }
    } else {
      if ( href === '/service/?mode=list&cat=0' ) {
        this.classList.add('current')
      }
    }

  })
}

const init = () => {

  replace_item()

  // カテゴリ一覧取得
  $.when( GET_CATEGORIES(`.${content}-catelist[data-plugin="getCategories"]`) ).done(() => {
    const $catList = $('.service-catelist')
    const $otherLink = $('<a href="/service/?mode=list&amp;cat=0" class="">その他</a>');

    $catList.append( $otherLink ).currentMenu({mode:0,default:999});
  })

}

export default function WORKS() {
  $(() => {
    init()
    if (w.query_string('article')) detail_init(w.query_string('article'))
  })
}